import script from "./UUniversalRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./UUniversalRow.vue?vue&type=script&setup=true&lang=ts"

import "./UUniversalRow.vue?vue&type=style&index=0&id=0674b186&lang=css"

const __exports__ = script;

export default __exports__